<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <section class="content-header">
    <h1>
      {{title}}
      <small>Control panel</small>
    </h1>
    <ol class="breadcrumb">
      <li>
        <a routerLink="">
          <i class="fa fa-dashboard"></i> Home
        </a>
      </li>
      <li class="active">{{title}}</li>
    </ol>
  </section>
  <!-- Main content -->
  <section class="content">

    <div class="row">
      <div class="col-xs-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">{{title}} Table</h3>
            <a routerLink="/layout-print/create" class="btn btn-success">Create</a>
          </div>

          <!-- /.box-header -->
          <div class="box-body table-responsive no-padding">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th>NAME</th>
                  <th class="w-1">UPDATED AT</th>
                  <th class="w-1">ACT.</th>
                </tr>
              </thead>
              <tbody *ngIf="!isLoading">
                <tr *ngFor="let layoutPrint of layoutPrintList; let i = index">
                  <td>
                    <span>{{ i + 1 }}</span>
                  </td>
                  <td>
                    <span>{{ layoutPrint.name }}</span>
                  </td>
                  <td>
                    <i class="fa fa-clock-o"></i>
                    {{ layoutPrint.updatedAt | date:'hh:mm dd-MM-yyyy' }}
                  </td>
                  <td>
                    <a routerLink="/layout-print/{{layoutPrint.id}}" class="btn btn-default">
                      <i class="fa fa-edit" aria-hidden="true"></i>
                    </a>
                    <button (click)="deleteLayoutPrint(layoutPrint)" class="btn btn-danger">
                      <i class="fa fa-close" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr *ngIf="layoutPrintList?.length === 0">
                  <td class="text-center" colspan="8">
                    <span>Can not found.</span>
                  </td>
                </tr>
                <tr *ngIf="layoutPrintList?.length !== 0">
                  <td colspan="8">
                    Displaying {{filterParams.page * filterParams.size + 1}} - {{ (filterParams.page) * filterParams.size + layoutPrintList?.length }}
                    of {{ totalElements }}
                    <ul *ngIf="filterParams.size < totalElements" class="pagination pull-right">
                      <li [class.disabled]="filterParams.page == 0" (click)="filterParams.page = filterParams.page - 1">
                        <a>
                          <span aria-hidden="true">«</span>
                          Previous</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 3" (click)="filterParams.page = 0">
                        <a>1</a>
                      </li>
                      <li [class.hidden]="filterParams.page < 4" class="disabled hidden">
                        <a>...</a>
                      </li>
                      <li *ngFor="let number of initPaginate()" [class]="filterParams.page == number ? 'active' : class" [class.hidden]="(filterParams.page + 2 < number || filterParams.page - 2 > number)"
                        (click)="filterParams.page = number">
                        <a>{{ number + 1 }}</a>
                      </li>
                      <li [class.hidden]="filterParams.page > totalPage - 5" class="disabled">
                        <a>...</a>
                      </li>
                      <li [class.hidden]="filterParams.page >  totalPage - 4" (click)="filterParams.page = totalPage -1">
                        <a>{{ totalPage }}</a>
                      </li>
                      <li [class.disabled]="filterParams.page == totalPage - 1" (click)="filterParams.page = filterParams.page + 1">
                        <a>
                          <span aria-hidden="true">»</span>
                          Next</a>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tfoot>
            </table>


            <p class="text-center" *ngIf="isLoading">
              <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              <span class="sr-only">Loading...</span>
            </p>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
    </div>
  </section>
</div>


// WEBPACK FOOTER //
// /build/client-cms/src/app/layout-print/layout-print.component.html